import { ErrorAlertPanel } from 'components/v2/compiler/panels/Styles.styled';
import { confirmDelete } from 'components/v2/confirm-dialog/confirmDelete';
import WizardAddButton from 'components/v2/epd-wizard-inputs/WizardAddButton';
import React from 'react';
import { MaterialPropertiesListRecord } from 'types/dynamic-forms/records/MaterialPropertiesListRecord';
import useProperty from '../../hooks/useProperty';
import usePropertyPath, { PropertyPathStackProvider } from '../../hooks/usePropertyPath';
import MaterialPropertiesListRendererEntry from './MaterialPropertiesListRendererEntry';

const MaterialPropertiesListRenderer: React.FC<MaterialPropertiesListRecord> = ({ propertyId }) => {
  const propertyPath = usePropertyPath(propertyId);
  const { value, setValue, isVisible, isDisabled, errorMessage } = useProperty<any[]>(propertyPath);

  if (!isVisible) {
    return null;
  }

  const confirmDeleteMaterialProperty = (index: number) => {
    confirmDelete({
      caption: 'Are you sure you want to delete material property?',
      onConfirm: () => setValue(value.filter((_, i) => i !== index)),
    });
  };

  return (
    <>
      {errorMessage && <ErrorAlertPanel>{errorMessage}</ErrorAlertPanel>}

      {value.map((_, i) => (
        <PropertyPathStackProvider key={i} pushPath={[propertyId, i]}>
          <MaterialPropertiesListRendererEntry
            addedMaterialProperties={value}
            canBeDeleted={true}
            onDelete={() => confirmDeleteMaterialProperty(i)}
          />
        </PropertyPathStackProvider>
      ))}

      {!isDisabled && (
        <div>
          <WizardAddButton label="+ Add material property" onClick={() => setValue([...value, {}])} />
        </div>
      )}
    </>
  );
};

export default MaterialPropertiesListRenderer;
